var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerAgent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a8cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#60acef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89c0ef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(80 80) rotate(180)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    transform: "translate(21.196 21.211)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.43,
    height: 38.43,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37.43,
    height: 37.43,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_face-agent",
    "data-name": "Path / face-agent",
    d: "M30.654,24.021a13.408,13.408,0,0,0,.411-8.572,14.934,14.934,0,0,1-3.5.41A15.376,15.376,0,0,1,14.853,9.015a16.141,16.141,0,0,1-8.106,8.7,9.324,9.324,0,0,0-.069,1.39A12.715,12.715,0,0,0,19.138,32.059a11.99,11.99,0,0,0,5.09-1.141c.977,1.943,1.422,2.9,1.388,2.9a21.576,21.576,0,0,1-6.478,1.461,15.209,15.209,0,0,1-11.02-4.741,16.222,16.222,0,0,1-3.839-6.576H2V15.859H3.868A15.742,15.742,0,0,1,19.138,2.92a15.257,15.257,0,0,1,11,4.741,16.229,16.229,0,0,1,4.233,8.2h1.9v8h0v.107h-.1l-6.1,5.828-9.083-1.069V25.75h8.278l1.388-1.729m-16.2-5.329a1.858,1.858,0,0,1,1.371.606,2.08,2.08,0,0,1,0,2.851,1.909,1.909,0,0,1-1.371.588,2.024,2.024,0,0,1,0-4.046m9.34,0a2.024,2.024,0,1,1-1.954,2.032A1.979,1.979,0,0,1,23.8,18.692Z",
    transform: "translate(21.271 21.407)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerAgent);
export default __webpack_public_path__ + "static/media/customer-agent.b34371799f568cddf9d2b769260c2e8a.svg";
export { ForwardRef as ReactComponent };